import moment from 'moment';

function controller($scope) {
  let editing = null;
  $scope.endDate = moment().add(2, 'months').endOf('month').toDate();
  $scope.originalTransfers = {};

  $scope.setTransferDate = (t, date) => {
    t.transferAt = date;
  };

  $scope.isTransferDate = (t, date) => {
    if (date === undefined) { return false; }
    if ((t.transferAt === null) && (t.frequency !== 0)) { return false; }
    return moment(date).isSame(t.transferAt);
  };

  $scope.startEdit = (transfer, index) => {
    if (editing) $scope.back();
    const original = Object.assign({}, transfer);
    editing = { transfer, original, index };
    const workdays = transfer.category === 'deposit' ? 5 : 10;
    $scope.transferEarliestDate = moment().addWorkdays(workdays).startOf('day');
  };

  $scope.editing = i => editing && editing.index === i;

  $scope.back = () => {
    Object.assign(editing.transfer, editing.original);
    editing = null;
  };

  $scope.changed = () => {
    const { transfer, original } = editing;
    return ['transferAt', 'frequency', 'investmentAccountId', 'amountValue']
      .some(k => transfer[k] !== original[k]);
  };

  $scope.submit = () => {
    if (!$scope.changed()) return;
    const { transfer, original } = editing;
    editing = null;
    $scope.editTransfer({ transfer, original });
  };

  $scope.canEdit = t => t.frequency > 0 && t.status !== 'cancel_requested';

  $scope.canCancel = (t) => {
    if (t.category === 'transfer') {
      if (t.status === 'in_progress'|| t.status === 'completed' || t.isSigned) { return false; }
      return true;
    }
    return ['requested', 'active'].indexOf(t.status) > -1;
  };

  return $scope;
}

export default ['$scope', controller];
